export enum ShapeColor {
    BLACK = 'rgb(0,0,0)',
    WHITE = 'rgb(255,255,255)',
    GREY = 'rgb(155,155,155)',
    RED = 'rgb(255,0,0)',
    GREEN = 'rgb(0,255,0)',
    BLUE = 'rgb(0,0,255)',
    YELLOW = 'rgb(255,255,0)',
    PURPLE = 'rgb(128,0,128)',
    BROWN = 'rgb(110,60,34)',
    ORANGE = 'rgb(255,89,0)',
    PINK = 'rgb(255,0,255)',
}